import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { ClickOutsideDirective } from 'app/shared/click-outside/click-outside.directive';

@NgModule({
  imports: [CommonModule, BrowserModule],
  declarations: [ClickOutsideDirective],
  exports: [ClickOutsideDirective],
  providers: [],
})
export class ClickOutsideModule {}
